import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { renderIcon } from '~/shared/components/icons';

const SidebarLink = ({ title, icon, newLink, route, onClick }) => {
    return (
        <NavLink
            to={route}
            onClick={onClick}
            isActive={(match, location) => {
                if (match) {
                    if (match.url === '') {
                        return false;
                    }
                    // console.log('match', match);
                    return match.path;
                }
            }}
            activeClassName='sidebar__link-active'
        >
            <span className='sidebar__link mb-2'>
                <span className='sidebar__link-icon'>{renderIcon(icon)}</span>
                <p className='sidebar__link-title'>
                    {title}
                    {newLink ? (
                        <Badge className='sidebar__link-badge'>
                            <span>New</span>
                        </Badge>
                    ) : (
                        ''
                    )}
                </p>
            </span>
        </NavLink>
    );
};

SidebarLink.propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.string,
    newLink: PropTypes.bool,
    route: PropTypes.string,
    onClick: PropTypes.func,
};

SidebarLink.defaultProps = {
    icon: '',
    newLink: false,
    route: '/',
    onClick: () => {},
};

export default SidebarLink;
